<template>
  <card-block>
    <card-header>
      Список цветов одежды
      <template v-slot:right>
        <router-link :to="{name: 'dictionary-color.create'}" v-if="can('module.dictionary.color-create')">
          Добавить цвет
        </router-link>
      </template>
    </card-header>
    <card-body>
      <spinner-block v-model="progress">
        <div class="mb-3 row">
          <div class="col-12 col-md-2">

          </div>
          <div class="col-12 col-md-5">
          </div>

        </div>
        <div v-if="data && data.data && data.data.length">
          <table class="table table-hover">
            <thead>
            <tr>
              <th class="pr-0" style="width: 1rem;"></th>
              <th>Название</th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in data.data" :key="row.id">
              <th class="pr-0">
                <i class="fas fa-circle small"
                   :title="row.is_active ? 'Активен' : 'Неактивен'"
                   :class="row.is_active ? 'text-success' : 'text-danger'"></i>
              </th>
              <td class="limit-length">
                <i class="fas fa-circle mr-2" v-if="row.color && row.color.length == 6"
                   :style="{color: '#'+row.color}"></i>
                <router-link :to="{name: 'dictionary-color.detail', params: {id: row.id}}" class="main-link">
                  {{ row.name ? row.name : '—' }}
                </router-link>
              </td>
              <td class="text-right">

              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info">Список пуст</div>
      </spinner-block>
      <gui-paginate :data="data" ref="paginate" @change="getList"/>
    </card-body>
  </card-block>
</template>

<script>

export default {
  data: function () {
    return {
      data: null,
      progress: true,
      filter: {}
    }
  },
  props: {},
  computed: {},
  beforeMount() {
    this.filter = storageLoad('filter_' + this.$route.name, this.filter);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {

      let v = _.clone(this.filter);
      v.search = '';
      storageSet('filter_' + this.$route.name, v);

      axiosGetValue('/api/admin/dictionary-color/list', {
            page: this.$refs.paginate.currentPage,
            per_page: this.$refs.paginate.perPage,
            filter: this.filter,
          },
          e => this.data = e, e => this.progress = e
      )
    }
  }
}
</script>